// plugins/antd-plugin.ts
import { message, notification } from 'ant-design-vue';
export default defineNuxtPlugin((nuxtApp) => {
  console.log('我的插件已加载！')
  return {
    provide: {
      // 注入全局消息提示方法
      message: message,
      // 注入全局通知提醒方法
      notification: notification,
    },
  }
})
